import styled, { CSSProperties } from 'styled-components';
import { numericToPx } from 'utils/styles/numeric-to-px';
import { DEVICE } from 'constants/app/breakpoints';

export const Wrapper = styled.div<{
  $width?: CSSProperties['width'];
  $height?: CSSProperties['height'];
  $isSelected?: boolean;
}>`
  width: ${({ $width }) => numericToPx($width) || '100%'};
  height: ${({ $height }) => numericToPx($height) || '100%'};
  background: var(--v3-black-0);
  border: 1px solid var(--v3-black-2);
  padding: 16px;
  border-radius: 20px;
  text-align: left;
  display: inline-block;
  cursor: pointer;
  position: relative;
  border: 1.4px solid
    ${({ $isSelected }) =>
      $isSelected ? `var(--v3-primary-color)` : `var(--v3-black-2)`};
`;

export const CardContent = styled.div`
  &&& {
    background-color: var(--v3-black-0);
    border-radius: 20px;
    position: relative;
    text-align: left;
    cursor: pointer;
    overflow: hidden;

    .ant-image {
      display: block;
    }

    img,
    .ant-skeleton-element {
      border-radius: 20px;
      height: 144px;
      width: 100%;
    }

    @media screen and ${DEVICE.xl} {
      max-width: 100%;
      img {
        width: 100%;
      }
    }
  }
`;

export const Meta = styled.div`
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  margin-top: -56px;
  position: relative;
  left: 16px;
  margin-right: 16px;
  .collection-meta-info {
    text-align: left;
    width: 100%;
  }
  .collection-name {
    width: 100%;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    font-weight: 700;
    font-size: 16px;
    line-height: 20px;
    display: block;
    text-align: left;
  }
  .collection-nft-count {
    color: var(--v3-text-color-secondary);
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
    display: block;
    text-align: left;
  }
`;

export const CollectionLogo = styled.div`
  border: 3px solid var(--v3-black-0);
  border-radius: 50%;
  width: fit-content;

  img {
    height: 64px;
  }
`;

export const MenuItem = styled.div`
  background-color: transparent !important;
  display: flex;
  flex-direction: row;
  gap: 15px;
  align-items: center;
  justify-content: space-between;
  color: var(--v3-text-color-secondary);
  padding: 12px;
  font-size: 15px;
  font-style: normal;
  font-weight: 500;
  line-height: 20px;
  letter-spacing: -0.3px;

  & span {
    font-size: 20px;
  }
`;

export const CollectionCardMenuToggle = styled.div`
  padding: 7px 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: var(--v3-black-0);
  border-radius: 8px;
  cursor: pointer;

  &:hover {
    background: var(--v3-black-1);
  }
`;

export const CollectionLogoWrapper = styled.div`
  display: flex;
  cursor: pointer;
  width: max-content;
`;

export const DetailWrapper = styled.div`
  display: flex;
  overflow: hidden;

  && {
    li.ant-dropdown-menu-item {
      padding: unset;
    }
  }
`;
